"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userWalletTransactionsController = function () {
  function userWalletTransactionsController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userWalletTransactionsController);
  }

  (0, _createClass3.default)(userWalletTransactionsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.walletTransactions,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No Transactions."
        },
        columns: [{ field: "creationDate", title: "Date", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #" }, { field: "transactionType", title: "Type", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getTransactionType(dataItem.transactionType);
          } }, { field: "total", title: "Total", filterable: false, width: "4rem", template: "#= '$' + (total/100).toFixed(2) #" }, { field: "transactionReason", title: "Reason", filterable: false, width: "8rem", template: function template(dataItem) {
            return "" + _this._getTransactionReason(dataItem.transactionReason);
          } }, { field: "transactionOwner", title: "Owner", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getTransactionOwner(dataItem.transactionOwner);
          } }]
      };
    }
  }, {
    key: "_getTransactionType",
    value: function _getTransactionType(type) {
      switch (type) {
        case _constants2.default.walletTransactionType.ADD:
          return "Add";
        case _constants2.default.walletTransactionType.DEDUCT:
          return "Deduct";
        case _constants2.default.walletTransactionType.REFUND:
          return "Refund";
      }
    }
  }, {
    key: "_getTransactionReason",
    value: function _getTransactionReason(reason) {
      switch (reason) {
        case _constants2.default.walletTransactionReason.ACCOUNT_CREATED:
          return "Account Created";
        case _constants2.default.walletTransactionReason.JOB_POSTED:
          return "Job Posted";
        case _constants2.default.walletTransactionReason.JOB_CANCELLED:
          return "Job Cancelled";
        case _constants2.default.walletTransactionReason.ADMIN_ACTION:
          return "Admin Action";
        case _constants2.default.walletTransactionReason.SINGLE_ONE_OFF_JOB_PURCHASE:
          return "Single One-off Job Purchase";
        case _constants2.default.walletTransactionReason.SINGLE_RECURRING_JOB_PURCHASE:
          return "Single Recurring Job Purchase";
        case _constants2.default.walletTransactionReason.WALLET_PAYMENT:
          return "Wallet Payment";
        case _constants2.default.walletTransactionReason.JOB_CANCELLED_BY_HELPER:
          return "Job Cancelled by Helper";

      }
    }
  }, {
    key: "_getTransactionOwner",
    value: function _getTransactionOwner(owner) {
      switch (owner) {
        case _constants2.default.walletTransactionOwner.UNSPECIFIED:
          return "Unspecified";
        case _constants2.default.walletTransactionOwner.USER:
          return "User";
        case _constants2.default.walletTransactionOwner.SYSTEM:
          return "System";
        case _constants2.default.walletTransactionOwner.ADMIN:
          return "Admin";
      }
    }
  }]);
  return userWalletTransactionsController;
}();

exports.default = userWalletTransactionsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-wallet-transactions/user-wallet-transactions.controller.js
 **/